/** @format */

import ResourceIndex from "./ResourceIndex";
import ResourcePage from "./resourcePage/ResourcePage";

import SubjectPage from "../subject/SubjectPage";
import SubjectsIndex from "../subject/SubjectsIndex";
import UploadBL from "./upload/UploadBL";
import UploadOther from "./upload/UploadOther";
import SelectResource from "./selectResource/SelectResource";

const resourcesRoutes = [
  {
    index: true,
    element: <SubjectsIndex />,
  },
  {
    path: ":subject",
    element: <SubjectPage />,
    children: [
      {
        index: true,
        element: <ResourceIndex />,
      },
      {
        path: "r/:resourceId/:type/:qualification",
        element: <ResourcePage />,
      },
    ],
  },
  {
    path: "upload-bl",
    element: <UploadBL />, // TODO: should user token be checked here?
  },
  {
    path: "upload",
    element: <UploadOther />,
  },
  {
    path: "select-resource",
    element: <SelectResource />,
  },
];

export default resourcesRoutes;
